
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Icon/Arrow Fat Down","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"data-name":"Masked Area","transform":"translate(-2081 -1782)","fill":"currentColor","stroke":"currentColor","d":"M0 0h24v24H0z"}})])]),_c('g',{attrs:{"data-name":"Icon/Arrow Fat Down","transform":"translate(2081 1782)","clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"Union 3","d":"M-2066-1777v6h3l-6 8-6-8h3v-6z","fill":"currentColor","stroke":"currentColor"}})])])
          )
        }
      }
    